import React from 'react';
import { Container } from '@material-ui/core';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import ReportEditForm from './ReportEditForm';

import useStyles from './styles';

function ReportEditView() {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="FH Engel | Editar Reporte"
    >
      <Container maxWidth={false}>
        <Header />
        <ReportEditForm />
      </Container>
    </Page>
  );
}

export default ReportEditView;
